import { Field } from "@/components/panel";

// Industria/sector from the closed backend catalog (/catalogs.rubros); "Otro" asks for a detail.
export const RubroSelect = ({ rubros = [], otro, value, detalle, onChange, onDetalleBlur, error: err, testid }) => {
  const enDetalle = !!otro && value === otro;
  const error = enDetalle ? null : err;
  return (
  <div className="space-y-3">
    <label className="block">
      <span className="text-xs font-semibold text-[var(--brand-primary)]">Industria / sector</span>
      <select value={value || ""} onChange={(e) => onChange({ rubro: e.target.value, rubro_detalle: detalle || "" })} aria-invalid={!!error} data-testid={testid}
        className={`mt-1 w-full rounded-xl border-2 px-4 py-2.5 text-sm outline-none bg-white focus:border-[var(--brand-accent)] ${error ? "border-red-400" : "border-[var(--brand-border)]"}`}>
        <option value="">Elegí una opción…</option>
        {rubros.map((r) => <option key={r} value={r}>{r}</option>)}
      </select>
      {error && <span role="alert" className="block text-xs text-red-600 mt-1" data-testid={`${testid}-error`}>{error}</span>}
    </label>
    {enDetalle && (
      <Field label="Especificá la industria/sector" maxLength={120} value={detalle || ""} onBlur={onDetalleBlur} error={err}
        onChange={(e) => onChange({ rubro: value, rubro_detalle: e.target.value })} data-testid={`${testid}-detalle`} />
    )}
  </div>
  );
};

export const rubroError = (rubro, detalle, otro) =>
  !rubro ? "Elegí la industria/sector" : rubro === otro && !(detalle || "").trim() ? "Especificá la industria/sector" : null;
